/**
 * Query keys for react-query's useQuery.
 * These keys must be unique across the entire application, so be sure to
 * namespace them appropriately.
 */
export const sharedQueryKeys = {
  session: {
    user: 'session-user',
    geoData: 'session-geo-data',
  },
  translations: {
    show: 'translations-show',
    index: 'translations-index',
  },
};

